import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, MessageSquare, Loader2 } from "lucide-react";
import api from "@/lib/api";
import DisclaimerBanner from "@/components/DisclaimerBanner";

const SCENARIO_BADGE = {
  door: "bg-red-100 text-red-700",
  street: "bg-amber-100 text-amber-700",
  detained: "bg-zinc-200 text-zinc-700",
  phase2: "bg-blue-100 text-blue-700",
  general: "bg-emerald-100 text-emerald-700",
};

export default function History() {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/conversations").then((r) => {
      setItems(r.data);
      setLoading(false);
    });
  }, []);

  return (
    <div className="min-h-screen bg-zinc-50 pb-28">
      <div className="max-w-md mx-auto w-full px-5 pt-6">
        <button
          onClick={() => navigate("/dashboard")}
          className="flex items-center gap-2 text-sm font-semibold text-zinc-600 mb-4 hover:text-zinc-900"
          data-testid="history-back"
        >
          <ArrowLeft className="w-4 h-4" />
          Volver
        </button>

        <h1 className="text-3xl font-black tracking-tight text-zinc-900 mb-6">
          Mi historial
        </h1>

        {loading && (
          <div className="flex justify-center py-12">
            <Loader2 className="w-6 h-6 animate-spin text-zinc-500" />
          </div>
        )}
        {!loading && items.length === 0 && (
          <div className="bg-white border-2 border-zinc-200 rounded-xl p-8 text-center">
            <MessageSquare className="w-10 h-10 text-zinc-300 mx-auto mb-3" />
            <p className="text-zinc-600">Aún no tienes conversaciones.</p>
          </div>
        )}
        {!loading && items.length > 0 && (
          <div className="flex flex-col gap-3">
            {items.map((c) => (
              <div
                key={c.id}
                data-testid={`history-item-${c.id}`}
                className="bg-white border border-zinc-200 rounded-xl p-4"
              >
                <div className="flex items-start justify-between gap-3 mb-2">
                  <h3 className="font-bold text-zinc-900 leading-tight">{c.title}</h3>
                  <span className={`text-xs font-bold px-2 py-1 rounded-full ${SCENARIO_BADGE[c.scenario] || "bg-zinc-100"}`}>
                    {c.scenario}
                  </span>
                </div>
                <p className="text-xs text-zinc-500 mb-3">
                  {new Date(c.updated_at).toLocaleString("es-MX")}
                </p>
                {c.messages.slice(-2).map((m, i) => (
                  <div key={`${c.id}-msg-${i}`} className={`text-sm mb-1 ${m.role === "assistant" ? "text-blue-900" : "text-zinc-700"}`}>
                    <span className="font-semibold capitalize">{m.role === "assistant" ? "IA" : "Tú"}:</span>{" "}
                    {m.content.length > 100 ? m.content.slice(0, 100) + "…" : m.content}
                  </div>
                ))}
              </div>
            ))}
          </div>
        )}
      </div>
      <DisclaimerBanner />
    </div>
  );
}
